function TimeDisplay(handle) {
	this.handle = handle;

    this.dt = null;
	this.hour = null;
	this.minute = null;

	this.pixPerMin = 66;

	this.dx = null; // drag distance in pixels
	this.dm = null; // drag in minutes
	this.lf = 0; // left value of time1 span
	this.tar = null; //
	this.active = false;

	this.elem = UI.div('timeDisplay', [
		this.time1 = UI.span(),
		this.time2 = UI.span()
	]);
	handle.appendChild(this.elem);
}

TimeDisplay.prototype = {
	setTime: function (utc) {
		if (utc) this.dt = new Date(utc);
		if (this.active || this.dt == null) return;
		this.hour = this.dt.getUTCHours();
		this.minute = this.dt.getUTCMinutes();
		this.time1.innerHTML = MinsPast(this.hour, this.minute);
	},
	getTimeChange: function() {
		this.tar = Math.round(this.lf / this.pixPerMin) * this.pixPerMin;
		this.active = true;
		this.moveHome();
		return this.dm * 60000;
	},
	scrollTime: function (dx) {
        this.active = true;
		this.dx = dx;
		this.lf = dx % (this.pixPerMin);
		this.time1.style.left = this.lf + 'px';
		this.time1.innerHTML = this.offsetTime(dx, 0);
		this.placeNext();
		return this.dm * 60000;
	},
	placeNext: function () {
		if (this.lf < 0) {
			this.time2.style.left = this.lf + this.pixPerMin + 'px';
			this.time2.innerHTML = this.offsetTime(this.dx, 1)
		} else {
			this.time2.style.left = this.lf - this.pixPerMin + 'px';
			this.time2.innerHTML = this.offsetTime(this.dx, -1)
		}
	},
	offsetTime: function (dx, os) {
		var dm, h, m;
		if (dx < 0) {
			dm = Math.ceil(dx / this.pixPerMin) * -1;
		} else {
			dm = Math.floor(dx / this.pixPerMin) * -1;
		}
		this.dm = Math.round(dx / this.pixPerMin) * -1;
		m = this.minute + dm + os;
		h = this.hour;
		return this.adjustHours(h, m);
	},
	adjustHours: function (h, m) {
		while (m < 0) {
			m += 60;
			h--;
		}
		while (m > 59) {
			m -= 60;
			h++;
		}
		while (h < 0) h += 24;
		while (h > 23) h -= 24;
		return MinsPast(h, m);
	},
	settle: function () {
		// centers the active time to the center when dragging stops
		this.tar = Math.round(this.lf / this.pixPerMin) * this.pixPerMin;
		this.moveHome();
	},
	moveHome: function () {
		if (this.lf > this.tar) {
			if (this.lf - this.tar < 2) this.lf = this.tar;
			else this.lf -= 2;
		} else {
			if (this.tar - this.lf < 2) this.lf = this.tar;
			else this.lf += 2;
		}
		if (this.lf == this.tar) {
			this.lf = 0;
			this.tar = 0;
			this.active = false;
			this.setTime();
		} else {
			setTimeout(this.moveHome.bind(this), 20);
		}
		this.time1.style.left = this.lf + 'px';
		this.placeNext();
	}
};